(function () {
  const root = document.getElementById("sora-ai-chat");
  if (!root) return;

  const catalog = (() => {
    try {
      return JSON.parse(document.getElementById("sora-chat-catalog")?.textContent || "[]");
    } catch {
      return [];
    }
  })();

  const catalogByHandle = Object.fromEntries(catalog.map((p) => [p.handle, p]));

  const apiBase = (root.dataset.apiBase || "").replace(/\/$/, "");
  const fab = root.querySelector("[data-chat-fab]");
  const panel = root.querySelector("[data-chat-panel]");
  const closeBtn = root.querySelector("[data-chat-close]");
  const body = root.querySelector("[data-chat-body]");
  const form = root.querySelector("[data-chat-form]");
  const input = root.querySelector("[data-chat-input]");
  const sendBtn = root.querySelector("[data-chat-send]");
  const chipsWrap = root.querySelector("[data-chat-chips]");
  let chips = root.querySelectorAll("[data-chat-chip]");
  const history = [];
  let sessionId = null;

  function money(n) {
    if (n == null || Number.isNaN(n)) return "";
    try {
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
        maximumFractionDigits: 0,
      }).format(n);
    } catch {
      return "£" + n;
    }
  }

  function findProducts(predicates, limit = 3) {
    return catalog.filter(predicates).slice(0, limit);
  }

  /** Absolute https only — reject local /images/... paths (404 on Shopify). */
  function absoluteImage(src) {
    if (!src) return "";
    const s = String(src).trim();
    if (/^https?:\/\//i.test(s)) return s;
    if (s.startsWith("//")) return "https:" + s;
    return "";
  }

  function mergeProduct(serverProduct) {
    const local = catalogByHandle[serverProduct.handle] || {};
    return {
      ...local,
      ...serverProduct,
      url: serverProduct.url || local.url || `/products/${serverProduct.handle}`,
      image: absoluteImage(local.image) || absoluteImage(serverProduct.image) || "",
      variantId: local.variantId || serverProduct.variantId || null,
    };
  }

  async function hydrateProductImages(list) {
    const out = (list || []).map(mergeProduct);
    await Promise.all(
      out.map(async (p) => {
        if (p.image || !p.handle || p.isLink) return;
        try {
          const res = await fetch(`/products/${encodeURIComponent(p.handle)}.js`, {
            headers: { Accept: "application/json" },
          });
          if (!res.ok) return;
          const data = await res.json();
          const feat = data.featured_image || data.images?.[0];
          const raw =
            typeof feat === "string"
              ? feat
              : feat?.src || data.media?.[0]?.preview_image?.src || "";
          const abs = absoluteImage(raw);
          if (abs) p.image = abs;
          if (!p.variantId && data.variants?.[0]?.id) p.variantId = data.variants[0].id;
          if (p.price == null && data.price != null) p.price = Number(data.price) / 100;
        } catch {
          /* placeholder */
        }
      })
    );
    return out;
  }

  async function addToCart(variantId, btn) {
    if (!variantId) {
      window.location.href = btn?.dataset?.pdp || "/";
      return;
    }
    const prev = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Adding…";
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error("cart_add_failed");
      btn.textContent = "Added";
      setTimeout(() => {
        btn.textContent = prev;
        btn.disabled = false;
      }, 1800);
    } catch {
      btn.textContent = "View instead";
      btn.disabled = false;
      if (btn.dataset.pdp) window.location.href = btn.dataset.pdp;
    }
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function productCards(list) {
    if (!list.length) return "";
    const cards = list
      .map((p) => {
        const priceHtml =
          p.price != null ? `<span class="sora-chat__card-price">${money(p.price)}</span>` : "";
        const whyHtml = p.why
          ? `<small class="sora-chat__card-why">${escapeHtml(p.why)}</small>`
          : "";
        const etaHtml = p.eta
          ? `<small class="sora-chat__card-eta">${escapeHtml(p.eta)}</small>`
          : "";
        const mediaInner = p.image
          ? `<img class="sora-chat__card-img" src="${escapeHtml(p.image)}" alt="" width="80" height="80" loading="lazy" decoding="async" data-chat-img>`
          : `<span class="sora-chat__card-placeholder" aria-hidden="true"></span>`;
        const cta =
          p.variantId && !p.isLink
            ? `<button type="button" class="sora-chat__card-add" data-variant-id="${escapeHtml(String(p.variantId))}" data-pdp="${escapeHtml(p.url)}">Add to bag</button>`
            : "";
        return `<article class="sora-chat__card">
        <div class="sora-chat__card-media">${mediaInner}</div>
        <div class="sora-chat__card-body">
          <strong>${escapeHtml(p.title)}</strong>
          <span class="sora-chat__card-tag">${escapeHtml(p.tagline || p.category || "")}</span>
          ${whyHtml}
          ${etaHtml}
          <div class="sora-chat__card-row">
            ${priceHtml}
            <div class="sora-chat__card-actions">
              <a class="sora-chat__card-view" href="${escapeHtml(p.url)}">View</a>
              ${cta}
            </div>
          </div>
        </div>
      </article>`;
      })
      .join("");
    return `<div class="sora-chat__cards">${cards}</div>`;
  }

  function bindCardActions(container) {
    container.querySelectorAll("[data-variant-id]").forEach((btn) => {
      btn.addEventListener("click", () => addToCart(btn.dataset.variantId, btn));
    });
    container.querySelectorAll("img[data-chat-img]").forEach((img) => {
      img.addEventListener("error", () => {
        const ph = document.createElement("span");
        ph.className = "sora-chat__card-placeholder";
        ph.setAttribute("aria-hidden", "true");
        img.replaceWith(ph);
      });
    });
  }

  function linkify(text) {
    return String(text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\[\[product:([a-z0-9-]+)\]\]/gi, (_, handle) => {
        const p = catalogByHandle[handle];
        return p ? `<a href="${p.url}">${p.title}</a>` : handle;
      })
      .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener">$1</a>');
  }

  function wrapText(html) {
    return `<div class="sora-chat__msg-text">${html}</div>`;
  }

  function addMessage(role, html, plain) {
    const el = document.createElement("div");
    el.className = `sora-chat__msg sora-chat__msg--${role === "user" ? "user" : "bot"}`;
    el.innerHTML = html;
    body.appendChild(el);
    bindCardActions(el);
    body.scrollTop = body.scrollHeight;
    if (plain) history.push({ role: role === "user" ? "user" : "assistant", content: plain });
    return el;
  }

  function setQuickReplies(replies) {
    if (!chipsWrap || !Array.isArray(replies) || !replies.length) return;
    chipsWrap.innerHTML = "";
    replies.forEach((label) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "sora-chat__chip";
      btn.dataset.chatChip = "";
      btn.textContent = label;
      btn.addEventListener("click", () => replyTo(label));
      chipsWrap.appendChild(btn);
    });
    chips = chipsWrap.querySelectorAll("[data-chat-chip]");
  }

  function setOpen(open) {
    panel.hidden = !open;
    fab.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) input?.focus();
  }

  function expertReply(raw) {
    const q = String(raw || "").toLowerCase();
    const picks = [];
    const signals = {};

    if (/under\s*£?\s*400|below\s*£?\s*400/.test(q)) signals.budget = { max: 400 };
    if (/bedroom|quiet|plug.?in|portable|rent/.test(q)) {
      signals.install = "portable";
      signals.noise = "quiet";
      signals.roomType = "bedroom";
    }

    if (/human|person|agent|advisor|call me|live help|manager|email|mailto/.test(q)) {
      return {
        text: "I can keep helping here with sizing and product picks. Checkout is on Shopify. Secure payment before anything ships.",
        products: [],
        quickReplies: ["Bedroom under £400", "Portable or split?", "Delivery timing"],
      };
    }

    if (/return|refund|warranty|care\+/.test(q)) {
      return {
        text: "Fans usually have a 30-day return window when unused. Split systems are larger installs. Check the product page before you buy if you need flexibility.",
        products: [],
        quickReplies: ["Help me choose", "Quiet bedroom"],
      };
    }

    if (/ship|deliver|track|postage|courier|dispatch/.test(q)) {
      return {
        text: "Delivery bands show at checkout for your address. We under-promise rather than claim next-day unless it's shown there.",
        products: [],
        quickReplies: ["Show me options", "Heatwave urgent"],
      };
    }

    if (/install|fitter|survey|bracket|pipe|fgas/.test(q)) {
      return {
        text: "Wall splits need a qualified installer. We supply the unit. Book your fitter separately. VIP Express Install may appear on split PDPs during heatwave conditions (optional).",
        products: [],
        quickReplies: ["Show portables", "Wall split options"],
      };
    }

    if (signals.install === "portable" || /portable|no install|rent|landlord/.test(q)) {
      picks.push(
        ...findProducts(
          (p) =>
            p.category === "Portable AC" &&
            (!signals.budget?.max || p.price <= signals.budget.max + 80),
          2
        )
      );
      picks.push(
        ...findProducts(
          (p) =>
            p.category === "Fans" &&
            (!signals.budget?.max || p.price <= signals.budget.max),
          1
        )
      );
      return {
        text: "Plug in route. No drilling. For a quiet bedroom under ~£400, a premium fan or compact portable is the honest fit before a four-figure split.",
        products: picks.slice(0, 3),
        quickReplies: ["Something quieter", "Real AC cooling", "Under £300"],
      };
    }

    if (/quiet|nursery|sleep|whisper|silent|draft/.test(q)) {
      picks.push(
        ...findProducts(
          (p) =>
            p.category === "Fans" ||
            (/quiet|sleep|circul|bladeless/i.test((p.tagline || "") + (p.title || "")) &&
              p.category === "Portable AC"),
          3
        )
      );
      return {
        text: "For quiet rooms: bladeless / circulator fans for gentle airflow, or a quiet portable if you need actual cooling without a wall install.",
        products: picks,
        quickReplies: ["Under £400", "Portable AC", "Wall split"],
      };
    }

    if (/server|data centre|datacentre|commercial|business/.test(q)) {
      return {
        text: "Commercial and server-room cooling lives under Critical Cooling. Scoped kit, not residential splits.",
        products: [],
        quickReplies: ["Home bedroom", "Shop / restaurant"],
      };
    }

    if (/best|recommend|help me choose|which|bedroom/.test(q) || signals.budget) {
      if (signals.budget?.max) {
        picks.push(
          ...findProducts((p) => p.category === "Fans" && p.price <= signals.budget.max, 1)
        );
        picks.push(
          ...findProducts(
            (p) => p.category === "Portable AC" && p.price <= signals.budget.max + 60,
            2
          )
        );
      } else {
        picks.push(...findProducts((p) => ["dreame-mf10", "meaco-fan-1056", "delonghi-pinguino-es72"].includes(p.handle), 3));
      }
      return {
        text: "Tell me: home or business, plug in vs wall split, room size, and budget. I'll narrow to 1 to 3 real SKUs from our catalog.",
        products: picks.filter(Boolean).slice(0, 3),
        quickReplies: ["Bedroom, quiet, under £400", "Wall split", "Heatwave urgent"],
      };
    }

    picks.push(...findProducts((p) => ["meaco-fan-1056", "delonghi-pinguino-es72", "dreame-mf10"].includes(p.handle), 3));
    return {
      text: "I'm your SORA concierge. A few quick questions beat a long form. Try a chip or describe the room.",
      products: picks,
      quickReplies: ["Bedroom, quiet, under £400", "Portable or split?", "Size 18 m²"],
    };
  }

  async function replyTo(text) {
    addMessage("user", linkify(text), text);
    const typing = document.createElement("div");
    typing.className = "sora-chat__typing";
    typing.textContent = "Concierge is typing…";
    body.appendChild(typing);
    body.scrollTop = body.scrollHeight;
    sendBtn.disabled = true;

    let answered = false;
    let bridgeFailed = false;
    if (apiBase) {
      try {
        const res = await fetch(`${apiBase}/api/chat/sales`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            sessionId,
            message: text,
            messages: history.slice(-12),
          }),
        });
        if (res.ok) {
          const data = await res.json();
          if (data.reply) {
            typing.remove();
            sessionId = data.sessionId || sessionId;
            const products = await hydrateProductImages(data.products || []);
            addMessage(
              "assistant",
              wrapText(linkify(data.reply)) + productCards(products),
              data.reply
            );
            if (data.quickReplies?.length) setQuickReplies(data.quickReplies);
            answered = true;
          }
        } else {
          bridgeFailed = true;
        }
      } catch {
        bridgeFailed = true;
      }
    }

    if (!answered) {
      typing.remove();
      if (apiBase && bridgeFailed) {
        const offlineMsg =
          "Concierge is briefly offline. Your message wasn't processed. Try again in a moment, or tap a chip below.";
        addMessage(
          "assistant",
          `<p class="sora-chat__offline">${offlineMsg}</p>`,
          offlineMsg
        );
        setQuickReplies(["Bedroom, quiet, under £400", "Portable or split?", "Delivery timing"]);
      } else if (!apiBase) {
        const local = expertReply(text);
        const products = await hydrateProductImages(local.products || []);
        addMessage(
          "assistant",
          wrapText(linkify(local.text)) + productCards(products),
          local.text
        );
        if (local.quickReplies?.length) setQuickReplies(local.quickReplies);
      } else {
        const retryMsg = "Something went wrong. Please try again.";
        addMessage("assistant", wrapText(retryMsg), retryMsg);
        setQuickReplies(["Bedroom, quiet, under £400", "Portable or split?"]);
      }
    }

    sendBtn.disabled = false;
  }

  fab?.addEventListener("click", () => setOpen(panel.hidden));
  closeBtn?.addEventListener("click", () => setOpen(false));
  chips.forEach((chip) =>
    chip.addEventListener("click", () => {
      replyTo(chip.textContent.trim());
    })
  );

  form?.addEventListener("submit", (event) => {
    event.preventDefault();
    const text = (input.value || "").trim();
    if (!text) return;
    input.value = "";
    replyTo(text);
  });

  input?.addEventListener("keydown", (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      form?.requestSubmit();
    }
  });

  const greeting =
    "Hello. I'm your SORA concierge. A few quick questions and I'll recommend real products with links to checkout.\n\nWhat's the space: home bedroom, open-plan lounge, or something commercial?";
  addMessage("assistant", wrapText(linkify(greeting)), greeting);
  setQuickReplies([
    "Bedroom, quiet, under £400",
    "Portable or split?",
    "Server room / data centre",
  ]);
})();
